import { Record } from 'immutable';

const struct = {
  street:      undefined,
  state:       undefined,
  city:        undefined,
  country:     undefined,
  postalCode:  undefined,
  countryCode: undefined,
  latitude:    undefined,
  longitude:   undefined,
};

export default class Address extends Record(struct, 'Address') {
  complete() {
    return [this.street, this.city, this.state, this.postalCode, this.country].filter((i) => i).join(', ');
  }

  cityLocation() {
    return [this.city, this.state, this.country].filter((i) => i).join(', ');
  }
}
